<h2 mat-dialog-title>
    Create Sector
  </h2>
  <button type="button" class="btn btn-link modal-close" (click)="cancel()">
    <svg width="24" height="24"
        viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 6L6 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M6 6L18 18" stroke="#03101F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</button>
<mat-dialog-content>
  <form class="">
            <div class="row my-2">
                <div class="col-sm-12">
                    <div class="mb-0">
                        <span class="black-text fs-14 mb-1">Sector Name</span>
                        <input type="text" [formControl]="sectorName" [required]="true" class="form-control bg-zircon"
                        [class.is-invalid]="
                          sectorName.invalid &&
                          sectorName.touched
                        "/>
                        <div *ngIf="
                            (sectorName.invalid &&
                             sectorName.touched) ||
                             sectorName.dirty">
                          <small *ngIf="sectorName.errors?.['required']" class="text-danger fs-13">Sector Name is required</small>
                          <small *ngIf="sectorName.errors?.['pattern']" class="text-danger fs-13">Please provide a valid Sector Name</small>
                        </div>
                    </div>
                </div>
            </div>
        </form>
      </mat-dialog-content>
      <mat-dialog-actions>
            <div class="row">
              <div class="col-sm-12 text-end">
                <button
                  type="button"
                  class="btn theme-btn-outline px-5 mt-md-0 mt-2"
                  (click)="cancel()">
                  Cancel
                </button>
                <button type="button" class="btn theme-btn ms-3 px-5 mt-md-0 mt-2" [disabled]="sectorName.untouched || sectorName.invalid" (click)="createSector()">Create</button>
              </div>
            </div>
          </mat-dialog-actions>
